import { jsxs as e, jsx as o } from "react/jsx-runtime";
const d = ({
  cancelButtonAction: t,
  cancelButtonText: r,
  confirmButtonAction: c,
  confirmButtonText: l,
  isFloating: a,
  redirectionClubText: n
}) => /* @__PURE__ */ e("div", { className: `modal-footer-container ${a ? "floating" : ""}`, children: [
  c && l && /* @__PURE__ */ o("button", { onClick: c, className: "modal-confirm-button", children: l }),
  /* @__PURE__ */ o("button", { onClick: t, className: "modal-cancel-button", children: r }),
  n && /* @__PURE__ */ o(
    "button",
    {
      onClick: () => {
        window.location.href = "/s/?clubProducts";
      },
      className: "modal-confirm-button redirection-club-button",
      children: n
    }
  )
] });
export {
  d as ModalFooter
};
